import { addQuestion } from './addQuestion';
import i18n from '../../../i18n';

export const addFirstQuestion = () =>
  addQuestion(
    i18n.t('FormCreator:categoryDefaultTitle', {
      categoryNumber: 1,
    }),
  );
